function numCounter(element, number, time, step) {
  let res = 0;
  const allTime = Math.round(time / (number / step));

  let interval = setInterval(() => {
    res += step;
    if (res >= number) {
      clearInterval(interval);
      res = number; // Щоб не перевищувало значення
    }
    element.innerHTML = `-${res}%`;
  }, allTime);
}

// Функція для анімації на основі скролу, з перевіркою по id
function animateDiscount(targetId, className) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.target.id === targetId) {
        const discountEls = entry.target.querySelectorAll(className);

        discountEls.forEach((discountEl) => {
          // Перевіряємо, чи вже є атрибут is-animated
          if (!discountEl.hasAttribute("is-animated")) {
            let discountText = discountEl.textContent.trim();
            let discountValue = parseInt(discountText.replace(/\D/g, ""), 10);

            // Запускаємо анімацію
            numCounter(discountEl, discountValue, 3000, 1);

            // Додаємо атрибут, щоб запобігти повторному запуску
            discountEl.setAttribute("is-animated", "true");
          }
        });
      }
    });
  });

  document.querySelectorAll("section").forEach((section) => {
    observer.observe(section);
  });
}

// Викликаємо функцію для кожного id, який хочеш анімувати
animateDiscount("discount-top", ".discount-circle-number");
animateDiscount("discount", ".discount-circle-number");
